import React from 'react'
import { useSelector } from 'react-redux'
import { selectActiveProjectLoading } from '~/selectors/projectData'
import Preview from '../Preview'
import { selectShowPlaceholder } from '~/selectors'
// ---

export default function TimelinePreview(props) {
  const isActiveProjectLoading = useSelector(selectActiveProjectLoading)
  const showPlaceholder = useSelector(selectShowPlaceholder)

  if (isActiveProjectLoading) {
    return null
  }

  return (
    <Preview {...props} showPlaceholder={showPlaceholder} />
  )
}
